import { Card, CardContent, Grid } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { SummaryCard } from "./SummaryCard";
import { useDashboard } from "../context/useDashboard";
import { TabletAndroid } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";

export const SummaryCards = () => {
  const { dashboardCounts, isLoadingDashboardCounts } = useDashboard();

  if (isLoadingDashboardCounts || !dashboardCounts) {
    return (
      <Grid container spacing={3} mb={3}>
        {[1, 2, 3, 4].map((index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box flex={1}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={3} mb={3}>
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <PeopleIcon
              sx={{
                fontSize: 40,
                color: "primary.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.activeUsers}
          label="Usuários Ativos"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <BusinessIcon
              sx={{
                fontSize: 40,
                color: "success.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.companies}
          label="Empresas"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <TabletAndroid
              sx={{
                fontSize: 40,
                color: "warning.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.equipment}
          label="Equipamentos"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <EventNoteIcon
              sx={{
                fontSize: 40,
                color: "warning.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.reservations}
          label="Reservas"
        />
      </Grid>
    </Grid>
  );
}; 